import { domain } from 'modules/data';

export const pageConfig = {
    innerActivePageId: 'line-item-reports_list_page',
    access: [domain.CompanyUserRole.Manager, domain.CompanyUserRole.Auditor, domain.CompanyUserRole.WorkflowManager],
};
